import { SHARED_API_URL } from '../../../constants/shared/ApiConstants';
import { LRS_PAGE } from '../../../constants/shared/LrsConstants';

const {
    BENCHMARK_PAGE,
    PROGRESS_PAGE,
    INSTRUCTIONS_PAGE,
    HOME_CONNECT_PAGE,
    DUAL_LANGUAGE_PAGE,
    STUDENT_SUMMARY_BENCHMARK_HISTORY_PAGE,
    STUDENT_SUMMARY_TEXT_READING_HISTORY_PAGE,
    STUDENT_SUMMARY_PROGRESS_PAGE,
} = LRS_PAGE;

const LrsPageMapper = appRootUrl => {
    const { BASE_URLS, SS_URL } = SHARED_API_URL(null, appRootUrl);
    const { BENCHMARK_URL, PROGRESS_URL, INSTRUCTIONS_URL, HOME_CONNECT_URL, DUAL_LANGUAGE_URL } =
        BASE_URLS;
    const { BENCHMARK_HISTORY, TRC_SUMMARY, PROGRESS } = SS_URL;

    return {
        [BENCHMARK_URL]: BENCHMARK_PAGE,
        [PROGRESS_URL]: PROGRESS_PAGE,
        [INSTRUCTIONS_URL]: INSTRUCTIONS_PAGE,
        [HOME_CONNECT_URL]: HOME_CONNECT_PAGE,
        [DUAL_LANGUAGE_URL]: DUAL_LANGUAGE_PAGE,
        [BENCHMARK_HISTORY]: STUDENT_SUMMARY_BENCHMARK_HISTORY_PAGE,
        [TRC_SUMMARY]: STUDENT_SUMMARY_TEXT_READING_HISTORY_PAGE,
        [PROGRESS]: STUDENT_SUMMARY_PROGRESS_PAGE,
    };
};

export default LrsPageMapper;
